// extracted by mini-css-extract-plugin
export var grid = "index-module--grid--AP20h";
export var heroVectorLeft = "index-module--heroVectorLeft--dmWMi";
export var heroVectorRight = "index-module--heroVectorRight--hC5fs";